import React, {useState, useEffect, useRef, useContext} from "react"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { getReviews } from "../../lib/call-api"
import { FormatDate } from "../../lib/site-functions"

import SwiperCore, { Navigation, Pagination, A11y, Autoplay } from "swiper"

//import 'swiper/swiper-bundle.min.css'
import "./reviews-main.scss"
import SiteContext from "../../context/site-context";

SwiperCore.use([Navigation, Pagination, A11y, Autoplay])

export default function ReviewsMain() {
  const [content, setContent] = useState([])
  const { loadingSetState } = useContext(SiteContext)

  const myRef = useRef(null)
  const offsetY = myRef.current?.getBoundingClientRect().y

  const [inView, setInView] = useState(() => {
    return false
  })

  useEffect(() => {
    getReviews().then(responce => {
      //console.log('Partners responce', responce);
      if (responce === undefined) {
        setContent([])
      } else if (responce.status !== 200) {
        setContent([])
      } else {
        setContent(responce.data.results)

        loadingSetState(prevValues => (
           {...prevValues, reviewsLoaded: true}
        ))
      }
    })
  }, [])

  useEffect(() => {
    if (inView === false) {
      if (offsetY < 350) {
        setInView(true)
      }
    }
  }, [offsetY])

  return (
    <div
      ref={myRef}
      className={
        "rev-section hidden " + (inView ? "visible animated fadeIn" : "")
      }
      style={{ minHeight: "490px"}}
    >
      <div className="push70"/>

      <div className="container">
        <div className="text-center">
          <i className="material-icons f48">format_quote</i>
          <div className="title-h1">Отзывы клиентов</div>
        </div>
        {content === [] ? (
          <p>Отзывов нет</p>
        ) : (
          <div className="reviews-slider">
            <Swiper
              spaceBetween={30}
              slidesPerView={2}
              speed={1000}
              autoplay={{ delay: 3000 }}
              pagination={{ clickable: true }}
            >
              {content.map(item => (
                <SwiperSlide key={item.id}>
                  <div className="element">
                    <div className="element-header relative">
                      <div className="subtitle f13">
                        {FormatDate(item.created_at)}
                      </div>
                      <div className="title bold black f16">
                        {item.author_name}
                      </div>
                    </div>
                    <div className="push20"/>
                    <div className="element-body">
                      <div className="table">
                        <div className="table-cell">{item.content}</div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
      <div className="push50"/>
    </div>
  )
}
